<template>
  <div class="privacy-policy-page">
    <PrivacyPolicy />
  </div>
</template>

<script>
import PrivacyPolicy from "@/components/public/pages/privacy-policy/PrivacyPolicy.vue";

export default {
  name: "LimeLoansPrivacyPolicyPage",

  components: { PrivacyPolicy },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
